import { frameForUser, tierForReputation } from '../utils/reputation';

// Wraps an avatar in a tier ring. Three modes:
//   solid     — single-color ring
//   gradient  — linear gradient ring
//   prismatic — multi-color rotating gradient (Mythic Frame tier)
// Pass either a `user` object or an explicit `reputation` number.
// Children render inside the ring (typically <UserAvatar />).
export default function TierFrame({
  user, reputation, size = 44, ringWidth = 3, glow = true, children, onClick
}) {
  const frame = user ? frameForUser(user) : tierForReputation(reputation).frame;
  const colors = frame?.colors || ['#5C546C'];
  const isPrismatic = frame?.ring === 'prismatic';
  const isGradient = frame?.ring === 'gradient' || isPrismatic;
  const ringDim = size;
  const innerDim = size - ringWidth * 2;

  const background = isGradient
    ? `conic-gradient(from 0deg, ${colors.join(', ')})`
    : colors[0];

  const wrapperStyle = {
    width: ringDim, height: ringDim,
    borderRadius: '50%',
    background,
    padding: ringWidth,
    display: 'inline-grid',
    placeItems: 'center',
    cursor: onClick ? 'pointer' : 'default',
    boxShadow: glow ? `0 0 14px ${frame?.glow || 'transparent'}` : 'none',
    animation: isPrismatic ? 'og-prismatic-spin 7s linear infinite' : 'none'
  };

  const innerStyle = {
    width: innerDim, height: innerDim,
    borderRadius: '50%',
    background: 'var(--bg)',
    display: 'grid', placeItems: 'center',
    overflow: 'hidden',
    animation: isPrismatic ? 'og-prismatic-counter 7s linear infinite' : 'none'
  };

  return (
    <span className="og-tier-frame" style={wrapperStyle} onClick={onClick}>
      <span style={innerStyle}>{children}</span>
      <style>{`
        @keyframes og-prismatic-spin {
          to { transform: rotate(360deg); }
        }
        @keyframes og-prismatic-counter {
          to { transform: rotate(-360deg); }
        }
      `}</style>
    </span>
  );
}
